/** Offline vehicle sync — tune here without rewriting the engine. */
export const SYNC_BATCH_SIZE = 10000;
export const SYNC_MAX_CONCURRENT = 2;
export const SYNC_BATCH_RETRIES = 3;
export const SYNC_ID_BATCH_SIZE = 5000;
export const SYNC_RECORDS_TIMEOUT_MS = 180000;
export const SYNC_RETRY_BASE_MS = 400;
